export const addSize1 = (p, delta) => ({
    width : p.width  + delta,
    height: p.height + delta,
});
